import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Paper, Typography, Avatar } from '@mui/material';
import { Schedule as DelayIcon } from '@mui/icons-material';

const DelayNode = ({ data, selected }) => {
  return (
    <Paper
      elevation={selected ? 8 : 2}
      sx={{
        padding: '12px 16px',
        borderRadius: 2,
        border: '2px solid',
        borderColor: selected ? 'primary.main' : '#607d8b',
        backgroundColor: selected ? 'primary.light' : '#eceff1',
        minWidth: 180,
        transition: 'all 0.2s'
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{ background: '#607d8b', width: 10, height: 10 }}
      />
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Avatar sx={{ width: 28, height: 28, backgroundColor: '#607d8b', color: 'white' }}>
          <DelayIcon fontSize="small" />
        </Avatar>
        <Typography variant="caption" sx={{ color: '#607d8b', fontWeight: 600 }}>
          DELAY
        </Typography>
      </Box>
      
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {data.label || 'Wait'}
      </Typography>
      
      {data.config?.duration && (
        <Typography variant="caption" color="text.secondary">
          {data.config.duration} {data.config.unit || 'minutes'}
        </Typography>
      )}
      
      <Handle
        type="source"
        position={Position.Bottom}
        style={{ background: '#607d8b', width: 10, height: 10 }}
      />
    </Paper>
  );
};

export default memo(DelayNode);